import { defineComponent as _defineComponent } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index2',
  setup(__props) {

// import "./tzjs_fy/javascript/jquery-1.9.1.min.js"
// import "./tzjs_fy/javascript/bookmark_config.js"
// import "./tzjs_fy/javascript/config.js"
// import "./tzjs_fy/javascript/LoadingJS.js"
// import "./tzjs_fy/javascript/main.js"

window.sendvisitinfo = function (type, page) {};
$("#progress_title").css("display", "none");
window.pointerup = function () {
  return false;
};

return (_ctx: any,_cache: any) => {
  return null
}
}

})